import $ from 'jquery';

export default function () {
    $('.header-search-wrapper .search-main').click(function () {
        const $toggle = $(this);
        const $form = $toggle.siblings('.search-form-main');

        $form.toggleClass('active-search');
        $toggle.closest('.navbar-info').toggleClass('has-open-search', $form.hasClass('active-search'));
        $form.find('.search-field').focus();
    });
    $('.form-search').submit(function (e) {
        $(this).find(".fa-search").removeClass(".fa-search").addClass("fa-spinner fa-spin");
    });
}